if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.classList.contains("item__count")) {
          BSS_B2B.observer?.cartSubject.listenCartCheckout();
        }
        if (
          item.target.className ===
          "shopify-section row--product col-12 product__list top"
        ) {
          window.location.reload();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  setTimeout(() => {
    BSS_B2B.observer?.cartSubject.listenCartCheckout();
    BSS_B2B.observer?.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 2000);
}
